import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "period-buttons" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.periods, (p) => {
      return (_openBlock(), _createElementBlock("button", {
        key: p.value,
        class: _normalizeClass({ active: p.value === $props.selected }),
        onClick: ($event: any) => (_ctx.$emit('change', p.value))
      }, _toDisplayString(p.label), 11, _hoisted_2))
    }), 128))
  ]))
}